export const GENERATE_VARIANTS = "GENERATE_VARIANTS";
export const GENERATE_VARIANTS_PENDING = "GENERATE_VARIANTS_PENDING";
export const GENERATE_VARIANTS_FAILURE = "GENERATE_VARIANTS_FAILURE";
export const GENERATE_VARIANTS_SUCCESS = "GENERATE_VARIANTS_SUCCESS";
export const GENERATE_VARIANTS_RESET = "GENERATE_VARIANTS_RESET";
